<template>
  <div class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="subpage-head-image" style="background-image: url('assets/img/subpage-head.jpg');">
      <div class="container">
        <h1>
          Keresés
          <span>Keressen a rendszerben lévő tagok között</span>
        </h1>
      </div>
    </div>

    <div class="submenu clearfix">
      <div class="container">
        <ul>
          <li :class="{active: this.searchtype == 'simple'}">
            <a v-on:click="changeSearchType('simple')" href="javascript:void(0)">Egyszerű kereső</a>
          </li>
          <li :class="{active: this.searchtype == 'advanced'}">
            <a v-on:click="changeSearchType('advanced')" href="javascript:void(0)">Bővített kereső</a>
          </li>
        </ul>
      </div>
    </div>

    <section v-if="searchtype == 'simple'" style="padding-bottom: 0px" class="container">
      <EgyszeruKereso :searchItems="searchItems" :searchOptions="searchOptions" :changeSearchOption="changeSearchOption" :clickSearch="clickSearch"  />
    </section>

    <section v-if="searchtype == 'advanced'" style="padding-bottom: 0px" class="container">
      <BovitettKereso :searchItems="searchItems" :searchOptions="searchOptions" :changeSearchOption="changeSearchOption" :clickSearch="clickSearch" :selected_searchOptions="selected_searchOptions" :comboAdd="comboAdd" :comboRemove="comboRemove"  />
    </section>

    <section id="searchResults">
      <div class="container">
        <div v-if="items.length > 0" class="search-result-head">
          <div class="title">
            Találatok
          </div>
          <div class="amount">
            Összesen <span>{{ items.length }}</span> találat <span>1</span> oldalon.
          </div>
        </div>
        <select v-if="items.length > 0" name="teszt" class="form-control auto-width">
          <option value="">Értékelés szerint növekvő</option>
          <option value="">Értékelés szerint csökkenő</option>
          <option value="">Név szerint növekvő</option>
          <option value="">Név szerint csökkenő</option>
          <option value="">Megtekintés szerint növekvő</option>
          <option value="">Megtekintés szerint csökkenő</option>
        </select>

        <div class="search-result-items">
          <div class="row">
            <div v-for="(item, i) in items" class="col-sm-6 col-md-4">
              <div class="search-result-item">
                <div class="content">
                  <div class="photo" :style="{'background-image': 'url(\'assets/img/'+item.photo+'\')'}">
                    <div class="icon student">
                      <i class="fa fa-envelope-o"></i>
                    </div>
                  </div>
                  <div class="name">
                    {{ item.name }}
                  </div>
                  <div class="user-type student">
                    {{ item.type }}
                  </div>
                  <div class="clearfix">

                  </div>
                  <div class="evaluation-wrapper">
                    <div class="title">
                      Értékelése
                    </div>
                    <div class="bar-wrapper">
                      <div class="bar-bg">
                        <div class="bar" :style="{'background-color':item.bar_color, width: item.evaulation+'%'}">

                        </div>
                      </div>
                      <div class="text">
                        {{ item.evaulation }}%
                      </div>
                    </div>
                  </div>
                  <div class="metadata">
                    <div class="col">
                      <div class="value">
                        {{ item.publications.amount }}
                      </div>
                      <div class="field">
                        Publikáció
                      </div>
                    </div>
                    <div class="col">
                      <div class="value">
                        {{ item.watched }}
                      </div>
                      <div class="field">
                        Megtekintés
                      </div>
                    </div>
                    <div class="col">
                      <div class="value">
                        {{ item.languages.amount }}
                      </div>
                      <div class="field">
                        Nyelvismeret
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <router-link class="button v2" :to="{ path: '/userpage', query: { id: item.id } }">Bővebben</router-link>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-if="items.length > 0" class="breadcrumbs clearfix">
          <ul>
            <li class="prev"><a href=""><img src="assets/img/arrow.png" alt=""/></a></li>
            <li><a class="active" href="">1</a></li>
            <li class="next"><a href=""><img src="assets/img/arrow.png" alt=""/></a></li>
          </ul>
          <div class="result">
            Összesen <span>{{ items.length }}</span> találat <span>1</span> oldalon.
          </div>
        </div>

      </div>
    </section>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>
<script>
import Vue from 'vue';
import HTMLHeader from './tpl_header.vue';
import HTMLFooter from './tpl_footer.vue';
import ProfileMenu from './tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function() {
    return {
      searchtype: 'advanced',
      items: [],
      errors: [],
      searchOptions: {
        items: [
          {
            value: "please_select",
            label: "-- válasszon --"
          },
          {
            value: "name",
            label: "Név"
          },
          {
            value: "neptun",
            label: "Neptun kód"
          },
          {
            value: "eletkor",
            label: "Életkor"
          },
          {
            value: "kezdes_eve",
            label: "Kezdés éve"
          },
          {
            value: "lezart_felevek",
            label: "Lezárt félévek"
          },
          {
            value: "kreditek",
            label: "Megszerzett kreditek"
          },
          {
            value: "szakdolgozat_cime",
            label: "Szakdolgozat címe"
          },
          {
            value: "szakdolgozat_ertekelese",
            label: "Szakdolgozat értékelése"
          },
        ],
        selected: "please_select"
      },
      selected_searchOptions: [
        {
          items: [
            {
              value: "please_select",
              label: "-- válasszon --"
            },
            {
              value: "name",
              label: "Név"
            },
            {
              value: "neptun",
              label: "Neptun kód"
            },
            {
              value: "eletkor",
              label: "Életkor"
            },
            {
              value: "kezdes_eve",
              label: "Kezdés éve"
            },
            {
              value: "lezart_felevek",
              label: "Lezárt félévek"
            },
            {
              value: "kreditek",
              label: "Megszerzett kreditek"
            },
            {
              value: "szakdolgozat_cime",
              label: "Szakdolgozat címe"
            },
            {
              value: "szakdolgozat_ertekelese",
              label: "Szakdolgozat értékelése"
            },
          ],
          selected: "please_select"
        }
      ],
      searchItems: {
        name: '',
        neptun: '',
        eletkor: '',
        kezdes_eve: {
          items: [
            {
              value: "2010",
              label: "2010"
            },
            {
              value: "2011",
              label: "2011"
            },
            {
              value: "2012",
              label: "2012"
            },
            {
              value: "2013",
              label: "2013"
            },
            {
              value: "2014",
              label: "2014"
            },
            {
              value: "2015",
              label: "2015"
            },
            {
              value: "2016",
              label: "2016"
            },
            {
              value: "2017",
              label: "2017"
            },
            {
              value: "2018",
              label: "2018"
            }
          ],
          selected: "2010"
        },
        lezart_felevek: {
          items: [
            {
              value: "1",
              label: "1"
            },
            {
              value: "2",
              label: "2"
            },
            {
              value: "3",
              label: "3"
            },
            {
              value: "4",
              label: "4"
            },
            {
              value: "5",
              label: "5"
            },
            {
              value: "6",
              label: "6"
            },
            {
              value: "7",
              label: "7"
            },
            {
              value: "8",
              label: "8"
            },
            {
              value: "9",
              label: "9"
            },
            {
              value: "10",
              label: "10"
            }
          ],
          selected: "1"
        },
        volt_mar_kulfoldon: {
          value: 1,
          selected: false
        },
        volt_mar_mentor: {
          value: 1,
          selected: false
        },
        szakdolgozat: {
          value: 1,
          selected: false
        },
        kreditek: '',
        szakdolgozat_cime: '',
        szakdolgozat_ertekelese: {
          items: [
            {
              value: "2",
              label: ">= 2"
            },
            {
              value: "3",
              label: ">= 3"
            },
            {
              value: "4",
              label: ">= 4"
            },
            {
              value: "5",
              label: "5"
            }
          ],
          selected: "2"
        },
        volt_mar_kulfoldon_ev: {
          items: [
            {
              value: "1",
              label: "1 év"
            },
            {
              value: "2",
              label: "2 év"
            },
            {
              value: "3",
              label: "3 év"
            },
            {
              value: "4",
              label: "4 év"
            },
            {
              value: "5",
              label: "5 év"
            }
          ],
          selected: "1"
        },
        eletkor: '',
        osztondij: {
          value: 1,
          selected: false
        },
        osztondij_ido: {
          items: [
            {
              value: "1",
              label: "1 félév"
            },
            {
              value: "2",
              label: "2 félév"
            },
            {
              value: "3",
              label: "3 félév"
            },
            {
              value: "4",
              label: "4 félév"
            },
            {
              value: "5",
              label: "5 félév"
            },
            {
              value: "6",
              label: "6 félév"
            },
            {
              value: "7",
              label: "7 félév"
            },
            {
              value: "8",
              label: "8 félév"
            },
            {
              value: "9",
              label: "9 félév"
            },
            {
              value: "10",
              label: "10 félév"
            }
          ],
          selected: "1"
        },
      }
    }
  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);

      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });
  },
  methods: {
    clickSearch: function() {
      this.items = this.$root.users;
    },
    changeSearchType: function(type) {
      this.searchtype = type;
    },
    changeSearchOption: function(val,index) {

    },
    comboAdd: function(searchOptions) {
      var insert_obj = JSON.parse(JSON.stringify(searchOptions))
      this.selected_searchOptions.push(insert_obj);
    },
    comboRemove: function(index) {
      this.selected_searchOptions.splice(index, 1);
    }
  }
}

Vue.component('EgyszeruKereso', {
  props: ['searchOptions', 'searchItems', 'clickSearch'],
  data: function() {
    return {
      errors: [],
      name: this.$root.user.name
    };
  },
  template: `
    <div class="row">
      <div class="col-sm-12">
        <combobox id="kereses_mezo" name="kereses_mezo" label="Keresés szempontja" :errors="errors" v-model="searchOptions" />
      </div>
      <div class="col-sm-12">
        <combobox v-if="searchItems[searchOptions.selected] && searchItems[searchOptions.selected].items" id="kereses_ertek" name="kereses_ertek" label="Keresés értéke" :errors="errors" v-model="searchItems[searchOptions.selected]" />
        <inputbox v-else id="kereses_ertek" name="kereses_ertek" label="Keresés értéke" :errors="errors" v-model="searchItems[searchOptions.selected]"></inputbox>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <div class="form-label">
            &nbsp;
          </div>
          <button v-on:click="clickSearch" type="button" class="button v2 with-icon"><i class="fa fa-search"></i>Keresés</button>
        </div>
      </div>
    </div>
  `,
  mounted: function() {
  },
  methods: {
  }
});

Vue.component('BovitettKereso', {
  props: ['changeSearchOption', 'searchOptions', 'searchItems', 'clickSearch', 'selected_searchOptions', 'comboAdd', 'comboRemove'],
  data: function() {
    return {
      errors: [],
      name: this.$root.user.name
    };
  },
  template: `
    <div>
    <div class="search-rows">
      <div :class="{right:(index != 0 && (index + 1) % 2 == 0)}" class="search-row-outer" v-for="(searchOption, index) in selected_searchOptions">
        <div class="search-row">
          <combobox :id="'kereses_mezo_'+index" :name="'kereses_mezo_'+index" label="Keresés szempontja" :errors="errors" :index="index" :change="changeSearchOption" v-model="selected_searchOptions[index]" />
          <combobox v-if="searchItems[searchOption.selected] && searchItems[searchOption.selected].items" id="kereses_ertek" name="kereses_ertek" label="Keresés értéke" :errors="errors" v-model="searchItems[selected_searchOptions[index].selected]" />
          <inputbox v-else id="kereses_ertek" name="kereses_ertek" label="Keresés értéke" :errors="errors" v-model="searchItems[selected_searchOptions[index].selected]"></inputbox>
          <div>
            <button v-if="selected_searchOptions.length > 1" v-on:click="comboRemove(index)" type="button" class="button only-icon"><i class="fa fa-trash-o"></i></button>
          </div>
        </div>
        <div class="and-outer">
          <div v-if="index % 2 == 0 && index != selected_searchOptions.length - 1" class="and">
            és
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <div class="form-label">
            &nbsp;
          </div>
          <button v-on:click="comboAdd(searchOptions)" type="button" class="button v2 with-icon"><i class="fa fa-plus"></i>Hozzáadás</button>
          <button style="margin-left:10px" v-on:click="clickSearch" type="button" class="button v2 with-icon"><i class="fa fa-search"></i>Keresés</button>
        </div>
      </div>
    </div>
    </div>
  `,
  mounted: function() {
  },
  methods: {
  }
});

</script>




// WEBPACK FOOTER //
// search.vue?0ba8ddca